
  //import {Vue} from "vue-property-decorator";
  //import Component from "vue-class-component";
  import {Component, Prop, Vue, Watch} from "vue-property-decorator";
  import { Alert } from "@/addons/Alert";
  //import { http } from "@/config/HttpClient";
  import { DateTime } from "luxon";
  import { useConsultorioStore } from '../../store/consultorioStore';
  import { globalStore } from '../../store/globalStore';
  import { consultorioService } from '../../services/ConsultorioService';
  
  @Component({
    name: "EditarForm",
  })
  
  export default class EditarForm extends Vue {
    @Prop() cita_selected!: any
    @Prop() swEditar!: boolean

    private globalStore = globalStore();
    private consultorioStore = useConsultorioStore();
    private consultorioService = consultorioService.getInstance();
    private tab:any = null;
    public dialog = false;
    
    
    cita= {
        id: null,
        paciente: '',
        paciente_ci: '',
        paciente_id: null,
        tratamiento_id: '',
        fecha: DateTime.now().toFormat("yyyy-MM-dd"),
        hora: DateTime.now().toFormat("HH:mm"),
        motivo: '',
        observaciones: '',
        costo: 0,
        convenio_id: null,  
    }
    valid = true;
    fecha = DateTime.now().toFormat('yyyy-MM-dd');
    
    get tratamientos(): any {
      return this.consultorioStore.tratamientos;
    }
    get convenios(): any {
      return this.consultorioStore.convenios;
    }
    mounted(){
      this.getTratamientos();
      this.cargarDatos();
      this.dialog = this.swEditar
    }

    closePaciente(){
      this.dialog=false;
    }

    getTratamientos(){
      this.consultorioService.getTratamientos()
    }
    
    guardar(){
      if (!this.$refs.form.validate()) {
        Alert.warning( `Lene todos los campos obligatorios (*)`)
          return;
        }
      
    Alert.confirm(`Se realizará la modificacion de la consulta`, 'Modificar consulta?').then(async result => {
        if(result.isConfirmed){
        await this.consultorioService.updateCita(this.cita)
        this.limpiar()
        this.$emit('close')
        this.$emit('listar')
        }
    })
    
      
    }
    
    cargarDatos(){
        this.cita.id = this.cita_selected.id;
        this.cita.paciente = this.cita_selected.paciente.nombre_completo;
        this.cita.paciente_ci = this.cita_selected.paciente.ci;
        this.cita.tratamiento_id = this.cita_selected.tratamiento_id;
        this.cita.fecha = DateTime.fromFormat(this.cita_selected.fecha_hora,'yyyy-MM-dd HH:mm:ss' ).toFormat("yyyy-MM-dd");
        this.cita.hora = DateTime.fromFormat(this.cita_selected.fecha_hora,'yyyy-mm-dd HH:mm:ss').toFormat("HH:mm");
        this.cita.motivo = this.cita_selected.motivo;
        this.cita.observaciones = this.cita_selected.observaciones
        this.cita.costo = this.cita_selected.costo;
        this.cita.convenio_id = this.cita_selected.convenio_id;
    }
    limpiar(){
      this.cita= {
        id: null,
        paciente: '',
        paciente_ci: '',
        paciente_id: null,
        tratamiento_id: '',
        fecha: DateTime.now().toFormat("yyyy-MM-dd"),
        hora: DateTime.now().toFormat("HH:mm"),
        motivo: '',
        observaciones: ''
    }
    }
    get loading(): boolean {
      return this.consultorioStore.loading;
    }
   
  }
  
  